

































import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component({
  name: 'NightlyRatesLine',
  components: {},
})
export default class NightlyRatesLine extends Vue {
  @Prop() protected color!: any;

  @Prop() protected type!: any;
}

